export default __webpack_public_path__ + "static/media/profile_pic.2c70eea9.png";